import SOperationBar from './s-operation-bar.jsx'

SOperationBar.install = function(Vue) {
  Vue.component(SOperationBar.name, SOperationBar)
}

export default SOperationBar